import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserConfirmationService} from '../../../user/services/user-confirmation.service';
import {TranslateService} from '@ngx-translate/core';
import {Utils} from '../../../../common/services/Utils';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';
import {AuthorizationOptions} from '../../../admin/components/authorization-options/AuthorizationOptions';
import {UserAuthorizationParameterService} from '../../../user/services/user-authorization-parameter.service';
import {AuthService} from '../../../../common/services/auth.service';
import {AuthorizationOptionsService} from '../../../admin/services/authorization-options.service';

declare let jQuery: any;

@Component({
  selector: 'app-user-confirmation',
  templateUrl: './user-confirmation.component.html',
  styleUrls: ['./user-confirmation.component.scss']
})
export class UserConfirmationComponent extends LangChange implements OnInit {

  cache: string;
  confirmation: any;
  user: any = {};
  passwordConfirmation: string;
  authParams: AuthorizationOptions;
  strength = 0;
  digitsPattern = /^[0-9]*$/;
  hasError: boolean;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _userConfirmationService: UserConfirmationService,
              private _utils: Utils,
              private authOptionsService: AuthorizationOptionsService,
              protected _translateService: TranslateService,
              private _authParamService: UserAuthorizationParameterService,
              private _authService: AuthService) {
    super(_translateService);
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      this.cache = params['id'];
      this.init();
    });
    this.authOptionsService.getAuthOptions().subscribe(data => {
      this.authParams = data;
      this.jQueryInit();
    });
  }

  init() {
    this._userConfirmationService.get(this.cache).subscribe(
      data => {
        this.confirmation = data;
      },
      error => {
        this._router.navigate(['/']);
      }
    );
  }

  jQueryInit() {
    this.strength = 0;
    jQuery(document).ready(() => {
      jQuery('#password').pStrength({
        'changeBackground': false,
        'onPasswordStrengthChanged': (passwordStrength, percetage) => {
          this.strength = percetage;
          jQuery('#myDisplayElement1').html(percetage + '%');
        },
      });
    });
  }

  onSubmit() {
    this.hasError = false;
    const resultSet = this.checkValiditySetString();
    const uniqueArray = Array.from(resultSet);
    let invalidSet = '';
    for (const i of uniqueArray) {
      invalidSet = invalidSet + i + ',';
    }
    if (invalidSet !== '') {
      this._utils.notifyError(this._translateService.instant('password_contain_err', null) + invalidSet.slice(0, -1), null);
      this.hasError = true;
    }
    if (this.strength < this.authParams.complexityLevel && this.authParams.setPasswordComplexityLevel) {
      this._utils.notifyError(this._translateService.instant('password_does_not_match_complexity_level'), null);
      this.hasError = true;
    }
    if (this.hasError) {
      return;
    }
    if (this.confirmation.password !== this.passwordConfirmation) {
      this._utils.notifyError(this._translateService.instant('passwords_mismatch'), null);
      return;
    }
    this.user.id = this.confirmation.userId;
    this.user.password = this.confirmation.password;
    this._userConfirmationService.save(this.user, this.confirmation.id).subscribe(
      response => {
        this._authService.login({login: response.data, password: this.user.password});
      },
      error => {
        this._utils.notifyError(this._translateService.instant('error_occurred'), null);
        console.error(error);
      }
    );
  }

  checkValiditySetString(): Set<string> {
    const tempSet = new Set();
    if (this.authParams.useSymbolsInPassword && !this.authParams.useLettersInPassword) {
      for (let i = 0; i < this.confirmation.password.length; i++) {
        const count = this.checkSymbolInTheSet(this.confirmation.password[i], this.authParams.symbolsValidSet);
        if (count === 0) {
          tempSet.add(this.confirmation.password[i]);
        }
      }
    } else if (!this.authParams.useSymbolsInPassword && this.authParams.useLettersInPassword) {
      for (let i = 0; i < this.confirmation.password.length; i++) {
        const count = this.checkSymbolInTheSet(this.confirmation.password[i], this.authParams.lettersValidSet);
        if (count === 0) {
          tempSet.add(this.confirmation.password[i]);
        }
      }
    } else if (this.authParams.useSymbolsInPassword && this.authParams.useLettersInPassword) {
      for (let i = 0; i < this.confirmation.password.length; i++) {
        const count1 = this.checkSymbolInTheSet(this.confirmation.password[i], this.authParams.symbolsValidSet);
        const count2 = this.checkSymbolInTheSet(this.confirmation.password[i], this.authParams.lettersValidSet);
        if (count1 === 0 && count2 === 0) {
          tempSet.add(this.confirmation.password[i]);
        }
      }
    }
    return tempSet;
  }

  checkSymbolInTheSet(c: string, str: string) {
    let count = 0;
    for (let j = 0; j < str.length; j++) {
      if (this.digitsPattern.test(c) || str[j] === c) {
        count++;
      }
    }
    return count;
  }

  onLangChange(language: Language): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/user-confirmation/user-confirmation.component.ts